import type { MenuItem } from '@/types';

/**
 * Knowledgebase docs menu
 */

export const referenceMenu: MenuItem[] = [
  {
    label: 'Networking Requirements',
    path: '/knowledge-base/reference/networking-requirements',
  },
  {
    label: 'Capabilities',
    path: '/knowledge-base/reference/capabilities',
  },
  {
    label: 'Portal',
    path: '/knowledge-base/reference/portal',
    openNested: true,
    submenu: [
      {
        label: 'Release Notes',
        path: '/knowledge-base/reference/portal-release-notes',
      },
    ],
  },
  {
    label: 'Encoder',
    path: '/knowledge-base/reference/encoder',
    openNested: true,
    submenu: [
      {
        label: 'Release Notes',
        path: '/knowledge-base/reference/encoder-release-notes',
      },
    ],
  },
  {
    label: 'Platform',
    path: '/knowledge-base/reference/platform-release-notes',
  },
];

export const releaseNotesMenu: MenuItem[] = [
  {
    label: 'CC Release Notes 20200429',
    path: '/knowledge-base/release-notes/CC-Release-Notes-20200429',
  },
  {
    label: 'Phenix Mobile SDK v2020.1.30',
    path: '/knowledge-base/release-notes/Phenix-Mobile-SDK-v2020.1.30-Pre-release-Notes',
  },
];

export const howToMenu: MenuItem[] = [
  {
    label: 'API Usage',
    path: '/knowledge-base/how-to/api-usage',
  },
  {
    label: 'Artificially lower bandwidth or bitrate',
    path: '/knowledge-base/how-to/how-and-why-to-artificially-lower-bandwidth-or-bitrate',
  },
  {
    label: 'Set up publishing or subscribing for only audio or only video',
    path: '/knowledge-base/how-to/set-up-publishing-or-subscribing-for-only-audio-or-only-video',
  },
  {
    label: 'Set up High Availability',
    path: '/knowledge-base/how-to/setting-up-high-availability-ingest-and-clients',
  },
  {
    label: 'Optimal RTMP encoder settings',
    path: '/knowledge-base/how-to/optimal-rtmp-encoder-settings',
  },
  {
    label: 'How do I find my stream key?',
    path: '/knowledge-base/how-to/how-do-i-find-my-stream-key',
  },
  {
    label: 'Preventing stream sharing',
    path: '/knowledge-base/how-to/preventing-stream-sharing',
  },
  {
    label: 'Debug tokens in the Portal',
    path: '/knowledge-base/how-to/debugging-tokens-in-the-portal',
  },
  {
    label: 'Display multiple copies of the same stream',
    path: '/knowledge-base/how-to/display-multiple-copies-of-the-same-stream',
  },
  {
    label: 'Use Edge Tokens',
    path: '/knowledge-base/how-to/edge-token-usage',
  },
  {
    label: 'Find the video dimension of the stream',
    path: '/knowledge-base/how-to/find-the-video-dimension-of-the-stream',
  },
  // {
  //   label: 'Find your SDK version',
  //   path: '/knowledge-base/how-to/how-to-find-your-sdk-version',
  // },
  {
    label: 'Measure timing',
    path: '/knowledge-base/how-to/how-to-set-up-measurement-of-timing-information',
  },
  {
    label: 'Create test input',
    path: '/knowledge-base/how-to/how-to-use-ffmpeg-to-create-test-input',
  },
  {
    label: 'Verify encoder ability to contribute via UDP',
    path: '/knowledge-base/how-to/how-to-verify-an-encoder-is-able-to-contribute-via-udp',
  },
  {
    label: 'Manage issues with installing Phenix SDKs',
    path: '/knowledge-base/how-to/managing-issues-with-installing-phenix-sdks',
  },
  {
    label: 'RTSP ingest from IP cameras',
    path: '/knowledge-base/how-to/rtsp-ingest-from-ip-cameras',
  },
  {
    label: 'Work with timestamps in reports',
    path: '/knowledge-base/how-to/working-with-timestamps-in-reports',
  },
  {
    label: 'How do I deal with corporate firewalls?',
    path: '/knowledge-base/how-to/firewalls',
  },
  {
    label: 'How do I record streams for VOD playback?',
    path: '/knowledge-base/how-to/vod-options',
  },
  {
    label: 'How do I set up ad insertion?',
    path: '/knowledge-base/how-to/ad-insertion',
  },
  {
    label: 'How do closed captions work in the Phenix system?',
    path: '/knowledge-base/how-to/closed-captions',
  },
  {
    label: 'How do I set up and use SRT Ingest?',
    path: '/knowledge-base/how-to/srt-ingest-setup-and-usage',
  },
  {
    label: 'How do I set up and use RTMP Ingest?',
    path: '/knowledge-base/how-to/rtmp-ingest-setup-and-usage',
  },
];

export const troubleshootMenu: MenuItem[] = [
  {
    label: 'Issues with Downloading Phenix Mobile SDKs',
    path: '/knowledge-base/troubleshooting/why-issues-downloading-mobile-sdks-from-github',
  },
  {
    label: 'Building an app with the iOS SDK',
    path: '/knowledge-base/troubleshooting/why-doesnt-my-app-build-with-the-ios-sdk',
  },
  {
    label: 'App does not receive callbacks when data quality changes',
    path: '/knowledge-base/troubleshooting/why-doesnt-my-app-receive-callbacks-when-data-quality-changes',
  },
  {
    label: 'Publishing does not result in a stream',
    path: '/knowledge-base/troubleshooting/publishing-does-not-result-in-a-stream',
  },
  {
    label: "Autoplay isn't working",
    path: '/knowledge-base/troubleshooting/why-isnt-autoplay-working',
  },
  {
    label: 'Playback blocked in battery saver mode',
    path: '/knowledge-base/troubleshooting/playback-blocked-battery-saver',
  },
];

export const faqMenu: MenuItem[] = [
  {
    label: 'What is the difference between a Channel and a Room?',
    path: '/knowledge-base/faqs/what-is-the-difference-between-a-channel-and-a-room',
  },
  {
    label: 'Does Phenix encrypt its Real-Time streams?',
    path: '/knowledge-base/faqs/does-phenix-encrypt-its-real-time-streams',
  },
  {
    label: 'How does Phenix define Real-Time vs Low Latency?',
    path: '/knowledge-base/faqs/how-does-phenix-define-real-time-vs-low-latency',
  },
  {
    label: 'How does Phenix compare with technologies such as CMAF?',
    path: '/knowledge-base/faqs/how-does-phenix-real-time-streaming-compare-with-protocols-such-as-cmaf',
  },
  {
    label: 'On which cloud platforms is the Phenix platform deployed?',
    path: '/knowledge-base/faqs/on-which-cloud-platforms-is-the-phenix-platform-deployed',
  },
  {
    label:
      'What is the recommended minimum hardware spec for devices to publish from a web browser to Phenix?',
    path: '/knowledge-base/faqs/rec-spec-for-devices-to-publish-from-web-browser-to-phenix',
  },
  {
    label: 'What WebSocket reconnect mechanisms are built into the Web SDK?',
    path: '/knowledge-base/faqs/are-there-websocket-reconnect-mechanisms-built-into-the-web-sdk',
  },
  {
    label: 'What are the benefits of the Phenix hardware encoder?',
    path: '/knowledge-base/faqs/what-are-the-benefits-of-the-phenix-hardware-encoder',
  },
  {
    label:
      'How does Phenix multi-bitrate transcoding work and how do I enable it?',
    path: '/knowledge-base/faqs/how-does-phenix-multi-bitrate-transcoding-work-and-how-do-i-enable-it',
  },
  {
    label: 'What bitrates are used for encoding and publishing?',
    path: '/knowledge-base/faqs/what-bitrates-are-used-for-encoding-and-publishing',
  },
  {
    label: 'How does Phenix adapt to challenging network connections?',
    path: '/knowledge-base/faqs/adaptivity-for-challenging-network-connections',
  },
  {
    label:
      'How does Phenix handle rapid join rates and broadcast size audiences?',
    path: '/knowledge-base/faqs/rapid-join-rates',
  },
  {
    label: 'Where can I see the status of the Phenix system?',
    path: '/knowledge-base/faqs/where-can-i-see-the-status-of-the-phenix-system',
  },
  {
    label: 'When do sessions and sessionIds expire?',
    path: '/knowledge-base/faqs/when-do-sessions-and-sessionids-expire',
  },
  {
    label: 'What is the digest field portion of the Auth token?',
    path: '/knowledge-base/faqs/what-is-the-digest-field-portion-of-the-auth-token',
  },
  {
    label: 'Which video players support Phenix?',
    path: '/knowledge-base/faqs/video-player-support',
  },
  {
    label: 'Which capture devices are compatible with Phenix?',
    path: '/knowledge-base/faqs/capture-device-compatibility',
  },
  {
    label: 'Where can I find documentation of the text chat feature?',
    path: '/knowledge-base/faqs/documentation-of-chat-feature',
  },
  {
    label: 'What size and bitrate should I use for publishing?',
    path: '/knowledge-base/faqs/suggested-publishing-bitrates',
  },
  {
    label: 'Does Phenix provide a video player?',
    path: '/knowledge-base/faqs/phenix-video-player',
  },
];

export const kbMenu: MenuItem[] = [
  {
    label: 'How-To',
    path: '/knowledge-base/how-to',
    submenu: howToMenu,
  },
  {
    label: 'Troubleshooting',
    path: '/knowledge-base/troubleshooting',
    submenu: troubleshootMenu,
  },
  {
    label: 'FAQs',
    path: '/knowledge-base/faqs',
    submenu: faqMenu,
  },
  {
    label: 'Reference Docs',
    path: '/knowledge-base/reference',
    submenu: referenceMenu,
  },
];
